import React, { useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
//Style
import {
  Body,
  Button,
  Container,
  CurrentState,
  CurrentStep,
  Error,
  ErrorAreas,
  FormGroup,
  FormSection,
  Fotter,
  Header,
  Instruction,
  Label,
  LabelCase,
  Loading,
  ServiceContainer,
  TextField,
  Title,
  TitleService,
  TypeCase,
  TypeContainer,
  TypePerson,
  TypePersonContainer,
} from "./style";
import SelectAreas from "@components/form/SelectAreas";
import { AppContext } from "@context";
//Types
import { TypesData } from "@context/types/data";
import { TypesPage } from "@context/types/page";
import { TypesPersonality } from "@context/types/legalpersonality";
import { IFormData } from "./interface";
import { IOptions } from "@components/form/Select/interface";
import { IGetAreas } from "@api/services/parameterization/interface";
//Components
import Select from "@components/form/Select";
//Services
import {
  getAllEntities,
  getAreas,
  getDocumentType,
  getEps,
  getMinorities,
} from "@api/services/parameterization";
import { TypesAnonymous } from "@context/types/anonymous";
import { useLocation } from "react-router-dom";
import { TypesLoading } from "@context/types/loading";
import { getAge } from "@utils/time";

const Step1 = () => {
  const location = useLocation();
  const [doctype, setDoctype] = useState<IOptions[]>([]);
  const [minority, setMinority] = useState<IOptions[]>([]);
  const [EPS, setEps] = useState<IOptions[]>([]);
  const [area, setArea] = useState<IGetAreas[]>([]);
  const { state, dispatch } = useContext(AppContext);
  const { data, islegal } = state;
  const methods = useForm<IFormData>({ defaultValues: data });
  const { register, handleSubmit, errors, control, setValue, watch } = methods;
  console.log(watch());
  const typeIssue = (location.state as { type: number }).type;
  const isCongratsOrSugestion = typeIssue === 4 || typeIssue === 3;
  console.log();
  const onSave = (data: IFormData) => {
    dispatch({ type: TypesData.RefreshData, payload: data });
    dispatch({ type: TypesPage.Next });
  };
  const selectLegal = () => {
    dispatch({ type: TypesPersonality.Legal });
    dispatch({ type: TypesPage.Reset });
    dispatch({ type: TypesAnonymous.NotAnonymous });
  };
  const selectNatural = () => {
    dispatch({ type: TypesPersonality.Natural });
    dispatch({ type: TypesPage.Reset });
  };
  useEffect(() => {
    (async () => {
      register({ name: "docType" }, { required: !isCongratsOrSugestion });
      register({ name: "epsId" }, { required: !isCongratsOrSugestion });
      dispatch({ type: TypesLoading.Loading });
      try {
        const responseDocumentype = await getDocumentType();
        const doctypes = responseDocumentype.map(({ id, name }) => ({
          label: name,
          value: id,
        }));
        setDoctype(doctypes);
        const responseMinorities = await getMinorities();
        const minorities = responseMinorities.map(({ id, name }) => ({
          label: name,
          value: id,
        }));
        setMinority(minorities);
        const responseEPS = await getAllEntities();
        const eps = responseEPS.info.map(({ id, name }) => ({
          label: name,
          value: id,
        }));
        setEps(eps);
        const responseArea = await getAreas();
        setArea(responseArea);
        dispatch({ type: TypesLoading.NotLoading });
      } catch (err) {
        dispatch({ type: TypesLoading.NotLoading });
      }
    })();
  }, []);
  const handleSelectChange = (option: IOptions, name: string) => {
    setValue(name, option);
  };
  return (
    <Container onSubmit={handleSubmit(onSave)}>
      <Header>
        <TypeContainer>
          <LabelCase>Radicar Nuevo Caso</LabelCase>
          <TypeCase color={location.state.color}>
            {location.state.title}
          </TypeCase>
        </TypeContainer>
        <TypePersonContainer>
          <TypePerson onClick={selectNatural} selected={!islegal}>
            Persona natural
          </TypePerson>
          <TypePerson onClick={selectLegal} selected={islegal}>
            Persona jurídica{" "}
          </TypePerson>
        </TypePersonContainer>
      </Header>
      <Body>
        <Title>Datos del paciente:</Title>
        <FormSection>
          <FormGroup area={"name"}>
            <Label>
              Nombre Completo *
              <TextField
                ref={register({ required: !isCongratsOrSugestion })}
                name="name"
                placeholder={"Escriba su nombre"}
              />
              {errors.name?.type === "required" && <Error>Es requerido</Error>}
            </Label>
          </FormGroup>
          <FormGroup area={"lastname"}>
            <Label>
              Apellidos *
              <TextField
                placeholder={"Escriba sus apellidos"}
                name={"lastname"}
                ref={register({ required: !isCongratsOrSugestion })}
              />
              {errors.lastname?.type === "required" && (
                <Error>Es requerido</Error>
              )}
            </Label>
          </FormGroup>
          <FormGroup area={"doctype"}>
            <Label>
              Documento *
              <Controller
                as={Select}
                options={doctype}
                placeholder={"Elije un tipo"}
                name={"docType"}
                control={control}
                onChange={(value: IOptions) => {
                  handleSelectChange(value, "docType");
                }}
              />
              {errors.docType?.type === "required" && (
                <Error>Es requerido</Error>
              )}
            </Label>
          </FormGroup>
          <FormGroup area={"document"}>
            <Label>
              Número de Documento *
              <TextField
                type="number"
                placeholder={"Número de Documento"}
                name={"document"}
                ref={register({ required: !isCongratsOrSugestion })}
              />
              {errors.document?.type === "required" && (
                <Error>Es requerido</Error>
              )}
            </Label>
          </FormGroup>
          <FormGroup area={"birthday"}>
            <Label>
              Fecha de Nacimiento *
              <TextField
                placeholder={"DD/MM/YYYY"}
                name={"birthday"}
                ref={register({
                  required: !isCongratsOrSugestion,
                  validate: {
                    birthday: (value) => {
                      if (isCongratsOrSugestion) return true;
                      return getAge(value) >= 0;
                    },
                  },
                })}
                type={"date"}
              />
              {errors.birthday?.type === "required" && (
                <Error>Es requerido</Error>
              )}
              {errors.birthday?.type === "birthday" && (
                <Error>Fecha no valida</Error>
              )}
            </Label>
          </FormGroup>
          <FormGroup area={"etnia"}>
            <Label>
              Etnia o minoría
              <Controller
                as={Select}
                control={control}
                options={[{ value: null, label: "Seleccione" }, ...minority]}
                placeholder={"Seleccione"}
                name={"minorityId"}
                onChange={(value: IOptions) => {
                  handleSelectChange(value, "minorityId");
                }}
              />
            </Label>
          </FormGroup>
          <FormGroup area={"eps"}>
            <Label>
              Entidades *
              <Controller
                as={Select}
                options={EPS}
                placeholder={"Seleccione"}
                name={"epsId"}
                control={control}
                onChange={(value: IOptions) => {
                  handleSelectChange(value, "epsId");
                }}
              />
              {errors.epsId?.type === "required" && <Error>Es requerido</Error>}
            </Label>
          </FormGroup>

          {/*  <FormGroup area={"service"}>
            <TitleService>
              Por Favor, Selecciona los servicios que aplican para tu caso:
            </TitleService>
            <ServiceContainer>
              {area.map(({ id, name }) => (
                <SelectAreas
                  key={id}
                  value={id}
                  name={"areas"}
                  label={name}
                  ref={register({ required: !isCongratsOrSugestion })}
                  checked={data.areas.includes("" + id)}
                />
              ))}
            </ServiceContainer>
            {errors.areas?.type === "required" && (
              <ErrorAreas>Es requerido</ErrorAreas>
            )}
          </FormGroup> */}
        </FormSection>
        <Fotter>
          <Instruction>
            Los campos marcados con " * " son obligatorios según la circular 008
            de 2018 de la Superintendencia Nacional de Salud.
          </Instruction>
          <CurrentStep>Paso 1 de 3</CurrentStep>
          <Loading>
            <CurrentState />
          </Loading>
          <Button>Siguiente</Button>
        </Fotter>
      </Body>
    </Container>
  );
};

export default Step1;
